import { Controller } from 'stimulus';

export default class SearchFilterController extends Controller {
  static targets = [ "dropdown", "trigger" ]

  connect() {
    this.initialTriggerText = this.triggerTarget.textContent;
    this.textPrefix = this.element.dataset.textPrefix || '';
    this.selectedClass = this.element.dataset.selectedClass || 'bg-purple-600 text-white';
    this.deselectedClass = this.element.dataset.deselectedClass || 'bg-white text-black';
    this.setTriggerText();
    this.addSubmitButton();
  }

  /**
   * Adds a hidden submit button to the form so that we can trigger JS
   * event handlers on the form (tried requestSubmit and dispatchEvent, but they didn't work)
   */
  addSubmitButton() {
    this.hiddenSubmit = document.createElement('input');
    this.hiddenSubmit.type = 'submit';
    this.hiddenSubmit.name = 'submit';
    this.hiddenSubmit.hidden = true;
    this.element.appendChild(this.hiddenSubmit);
  }

  search(event) {
    event.preventDefault();
    const form = event.target.closest('form');
    // A blank search drops the filter; disabled inputs are left out of the submitted params.
    const blank = !this.hasValue();
    const disabled = blank ? this.textInputs().filter(node => !node.disabled) : [];
    if (blank) this.dropMarkers();
    disabled.forEach(node => node.disabled = true);
    if (form.requestSubmit) {
      form.requestSubmit();
    } else {
      this.hiddenSubmit.click();
    }
    disabled.forEach(node => node.disabled = false);
    this.setTriggerText();
  }

  show() {
    this.dropdownTarget.hidden = false;
  }

  hide() {
    this.dropdownTarget.hidden = true;
  }

  toggle() {
    this.dropdownTarget.hidden = !this.dropdownTarget.hidden;
  }

  // The single clear action: unchecks options, empties text inputs, then submits without this filter.
  selectNone(event) {
    event.preventDefault();
    this.dropdownTarget.querySelectorAll('input:checked').forEach(node => node.checked = false);
    this.textInputs().forEach(node => node.value = '');
    this.search(event);
    this.hide();
  }

  textInputs() {
    return [...this.dropdownTarget.querySelectorAll('input[type="search"]')];
  }

  hasValue() {
    return this.dropdownTarget.querySelector('input:checked') != null ||
      this.textInputs().some(node => node.value.trim() !== '');
  }

  // The marker keeps a blank added filter visible; once it is searched blank or cleared it must go.
  dropMarkers() {
    this.element.querySelectorAll('[data-search-filter-marker]').forEach(node => node.remove());
  }

  updateTriggerText(text) {
    if (text == null) {
      this.triggerTarget.textContent = this.initialTriggerText;
      this.selectedClass.split(" ").forEach(c => this.triggerTarget.classList.remove(c));
      this.deselectedClass.split(" ").forEach(c => this.triggerTarget.classList.add(c));
    } else {
      this.triggerTarget.textContent = text;
      this.selectedClass.split(" ").forEach(c => this.triggerTarget.classList.add(c));
      this.deselectedClass.split(" ").forEach(c => this.triggerTarget.classList.remove(c));
    }
  }

  setTriggerText() {
    const labels = [
      ...this.dropdownTarget.querySelectorAll('input:checked')
    ].map(node =>
      document.querySelector(`label[for="${node.id}"]`).textContent
    );

    // A text filter has nothing checked; its typed value is the selection.
    const text = this.dropdownTarget.querySelector('input[type="search"]')?.value?.trim();
    if (labels.length == 0 && text) labels.push(`"${text}"`);

    if (labels.length == 0) {
      this.triggerTarget.textContent = this.initialTriggerText;
      this.selectedClass.split(" ").forEach(c => this.triggerTarget.classList.remove(c));
      this.deselectedClass.split(" ").forEach(c => this.triggerTarget.classList.add(c));
    } else if (labels.length == 1) {
      this.triggerTarget.textContent = [this.textPrefix, labels[0]].join(" ");
      this.selectedClass.split(" ").forEach(c => this.triggerTarget.classList.add(c));
      this.deselectedClass.split(" ").forEach(c => this.triggerTarget.classList.remove(c));
    } else {
      this.triggerTarget.textContent = [this.textPrefix, `${labels.length} selected`].join(" ");
      this.selectedClass.split(" ").forEach(c => this.triggerTarget.classList.add(c));
      this.deselectedClass.split(" ").forEach(c => this.triggerTarget.classList.remove(c));
    }
  }
}
